// src/App.js
import { BrowserRouter, Routes, Route, HashRouter, useNavigate, Navigate } from "react-router-dom";
import { useState,useEffect,useCallback } from "react";
import SplashStartScreen from "./pages/splashScreen/splashStartScreen";
import SplashAfterScreen from "./pages/splashScreen/splashAfterScreen";
import KYCVerificationForm from "./pages/profile/kyc";
import KYCVerificationAddressForm from "./pages/profile/address";
import KYCVerificationIdForm from "./pages/profile/id";
import DocumentSelectionScreen from "./pages/profile/doc";
import DocumentUploadScreen from "./pages/profile/doc";
import SelfieCaptureScreen from "./pages/profile/selfie";
import Home from "./pages/dashboard/home";
import DashApp from "./pages/dashboard/dashboard";
import Signup from "./pages/SignUp&Login/signUp";
import ConfirmCodeScreen from "./pages/SignUp&Login/confirmationCode";
import SigninPage from './pages/SignUp&Login/signIn'

import {  Loader2, RefreshCw, Zap, ShoppingBag, Settings, CreditCard } from 'lucide-react';
import ForgotPasswordPage from "./pages/SignUp&Login/forgetpassword";
import PrivacyPolicy from "./pages/profile/privacypolicy";
import AccountDeletion from "./pages/profile/accountdeletion";
import { API_BASE_URL } from "./config/api";

// --- Global Constants ---
const SESSION_API_URL = `${API_BASE_URL}/auth/session`;
// KEY FOR LOCAL STORAGE PERSISTENCE
const AUTH_TOKEN_KEY = 'authToken';

// --- 2. Protected Route Wrapper ---
const ProtectedRoute = ({ authToken, children }) => {
  // If no token exists, redirect to signin
  if (!authToken) {
    // Log redirection for debugging
    console.log("ProtectedRoute: No auth token found. Redirecting to /signin.");
    return <Navigate to="/signin" replace />;
  }
  // Log success for debugging
  console.log("ProtectedRoute: Auth token found. Rendering children.", authToken);
  return children;
};

function App() {
  // const [authToken, setAuthToken] = useState(null);
  // const [userSession, setUserSession] = useState(null);

  // // Function to clear auth state (passed to signout)
  // const clearAuth = () => {
  //   setAuthToken(null);
  //   setUserSession(null);
  // }

  // // Props bundle for the protected DashApp
  // const dashAppProps = {
  //   authToken,
  //   userSession,
  //   setUserSession,
  //   setAuthToken: clearAuth // Pass the clear function for sign out
  // };

 // Initialize state with token from localStorage if available
    const [authToken, setAuthTokenState] = useState(() => localStorage.getItem(AUTH_TOKEN_KEY));
    const [userSession, setUserSession] = useState(null); 
    const [isAuthLoading, setIsAuthLoading] = useState(true);

    // Custom setter function to handle both state and localStorage
    const setAuthToken = useCallback((token) => {
        if (token) {
            localStorage.setItem(AUTH_TOKEN_KEY, token);
        } else {
            localStorage.removeItem(AUTH_TOKEN_KEY);
        }
        setAuthTokenState(token);
    }, []);

    // Function to clear auth state (passed to DashApp for sign out)
    const clearAuth = () => {
        setAuthToken(null); // Clears state and localStorage
        setUserSession(null);
    }
    
    // EFFECT 1: Check for token on initial load (although done in useState initializer, this confirms)
    // and determines if we need to show a loading state before the protected route check
    useEffect(() => {
        // Since we initialize state from localStorage, this effectively just sets the loading flag
        setIsAuthLoading(false); 
        // Log the state of persistence
        console.log("App mounted. Token from localStorage:", authToken ? "Found" : "Not Found");
    }, []); 
    
    // Props bundle for DashApp
    const dashAppProps = { 
        authToken, 
        userSession, 
        setUserSession, 
        setAuthToken: clearAuth // Pass the clear function for sign out
    };
    
    // Log the contents of the props bundle
    console.log("dashAppProps on App render:", dashAppProps);

    // Render nothing while checking persistence, though this should be near instant
    if (isAuthLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
                <p className="ml-3 text-gray-600">Loading Session...</p>
            </div>
        );
    }
    
    return (
    <HashRouter>
      <Routes>
        {/* Initial splash screens */}
         
        <Route path="/" element={<SplashStartScreen />} />
        <Route path="/onboarding" element={<SplashAfterScreen />} />

        {/* Authentication Routes */}
        {/* Pass the setter function to SigninPage */}
        <Route path="/signin" element={<SigninPage setAuthToken={setAuthToken} />} />
         <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/otpconfirm" element={<ConfirmCodeScreen />} />


 <Route path="/privacy-policy" element={<PrivacyPolicy />} />
  <Route path="/account-deletion" element={<AccountDeletion />} />
        {/* Protected Routes - All routes under /home are protected */}
        {/* <Route
          path="/home/*"
          element={
            <ProtectedRoute authToken={authToken}>
              <DashApp {...dashAppProps} />
            </ProtectedRoute>
          }
        /> */}

        {/* Fallback route for /home without /* (needed for direct /home navigation) */}
        <Route path="/home" element={
          <ProtectedRoute authToken={authToken}>
            <DashApp {...dashAppProps} />
          </ProtectedRoute>
        } />
        {/* Redirect unhandled paths to signin or a default location */}
        <Route path="*" element={<Navigate to="/signin" replace />} />

        <Route path="/kycstart" element={<KYCVerificationForm />} />
        <Route path="/kycaddress" element={<KYCVerificationAddressForm />} />
        <Route path="/kycid" element={<KYCVerificationIdForm />} />
        <Route path="/kycdocselect" element={<DocumentUploadScreen />} />
        <Route path="/selfie" element={<SelfieCaptureScreen />} />
        {/* <Route path="/home" element={<DashApp />} /> */}


      </Routes>
    </HashRouter>
  );
}

export default App;
